import { getLowestFraction } from '@planter/common';
import { isOunce } from './imperialUnits.utils';
import { getMeasurementUnit } from './getMeasurementUnit';
export function getCorrectIngredientQuantityForEachMember(ingredient, locale, showPortion) {
    var _a;
    var portion = 'portion' in ingredient ? ingredient === null || ingredient === void 0 ? void 0 : ingredient.portion : ingredient.quantity;
    var unitOfMeasure = getMeasurementUnit(ingredient, showPortion ? portion : ingredient.quantity);
    var effectiveQty = showPortion ? Number(portion) : (_a = ingredient.quantity) !== null && _a !== void 0 ? _a : 0;
    if (isOunce(unitOfMeasure) &&
        effectiveQty > 3 &&
        !Number.isInteger(effectiveQty)) {
        return Math.round(effectiveQty) + ' ' + unitOfMeasure;
    }
    var integerQuantityPart = Math.floor(showPortion ? Number(portion) : ingredient.quantity | 0);
    var decimalQuantityPart = (!showPortion ? ingredient.quantity : Number(portion)) -
        integerQuantityPart;
    var fractionalValue = getLowestFraction(decimalQuantityPart);
    if (integerQuantityPart && decimalQuantityPart === 0) {
        // Se l'unità di misura è qualitativa, non mostrare il numero
        if ((unitOfMeasure === null || unitOfMeasure === void 0 ? void 0 : unitOfMeasure.toLowerCase()) === 'to taste') {
            return unitOfMeasure;
        }
        return integerQuantityPart + ' ' + (unitOfMeasure !== null && unitOfMeasure !== void 0 ? unitOfMeasure : '');
    }
    if (integerQuantityPart && decimalQuantityPart > 0) {
        var isIT = locale === 'it';
        if (isIT) {
            return "".concat(integerQuantityPart, " ").concat(unitOfMeasure, " e ").concat(fractionalValue);
        }
        return "".concat(integerQuantityPart, " ").concat(fractionalValue, " ").concat(unitOfMeasure);
    }
    if (!integerQuantityPart && decimalQuantityPart > 0) {
        return fractionalValue + ' ' + unitOfMeasure;
    }
    if (!integerQuantityPart && isNaN(decimalQuantityPart)) {
        return unitOfMeasure;
    }
}
